import { gql, useQuery } from "@apollo/client";

export const PERFORMER_NAME_QUERY = gql`
  query EpocusPerformerName($userId: String!) {
    user(_id: $userId) {
      person {
        firstname
        lastname
      }
    }
  }
`;

type PerformerNameData = {
  user?: {
    person?: {
      firstname?: string | null;
      lastname?: string | null;
    } | null;
  } | null;
};

export const UNASSIGNED_PERFORMER_LABEL = "Unassigned";

export const usePerformerName = (
  performerId: string | null | undefined,
): { displayName: string; loading: boolean } => {
  const { data, loading } = useQuery<PerformerNameData>(PERFORMER_NAME_QUERY, {
    variables: { userId: performerId ?? "" },
    fetchPolicy: "cache-first",
    skip: !performerId,
  });

  const resolvedName =
    [data?.user?.person?.firstname, data?.user?.person?.lastname]
      .map((part) => part?.trim())
      .filter(Boolean)
      .join(" ") || null;

  if (!performerId) {
    return { displayName: UNASSIGNED_PERFORMER_LABEL, loading: false };
  }

  const truncatedId =
    performerId.length > 8 ? `…${performerId.slice(-8)}` : performerId;

  return {
    displayName: resolvedName ?? truncatedId,
    loading: loading && resolvedName == null,
  };
};
